__turbopack_context__.v({
  "body": "ConsultationHero-module__WdDm2q__body",
  "changeButton": "ConsultationHero-module__WdDm2q__changeButton",
  "consultation": "ConsultationHero-module__WdDm2q__consultation",
  "consultationBody": "ConsultationHero-module__WdDm2q__consultationBody",
  "eyebrow": "ConsultationHero-module__WdDm2q__eyebrow",
  "header": "ConsultationHero-module__WdDm2q__header",
  "hero": "ConsultationHero-module__WdDm2q__hero",
  "selectedConcern": "ConsultationHero-module__WdDm2q__selectedConcern",
  "signalMark": "ConsultationHero-module__WdDm2q__signalMark",
  "signals": "ConsultationHero-module__WdDm2q__signals",
  "title": "ConsultationHero-module__WdDm2q__title",
  "topicButton": "ConsultationHero-module__WdDm2q__topicButton",
  "topicGrid": "ConsultationHero-module__WdDm2q__topicGrid",
  "topicHelper": "ConsultationHero-module__WdDm2q__topicHelper",
  "topicLegend": "ConsultationHero-module__WdDm2q__topicLegend",
  "topicLens": "ConsultationHero-module__WdDm2q__topicLens",
  "topicTitle": "ConsultationHero-module__WdDm2q__topicTitle",
  "visual": "ConsultationHero-module__WdDm2q__visual",
  "visualEyebrow": "ConsultationHero-module__WdDm2q__visualEyebrow",
});
